import { lazy } from 'react'

import { useParams } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  TravelApprovalsPageTabStatuses,
  type TravelEditPageParams,
  TravelStatusPageTabStatuses,
} from './types'
import { useTravelDetailsPresenter } from '../features/get-travel-details/presenters/TravelDetailsPresenter'

const TravelEditViewChunk = lazy(() =>
  import('../feature-sets/TravelEditView').then(({ TravelEditView }) => ({
    default: TravelEditView,
  }))
)

export const TravelEditPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()
  const { uuid } = useParams<TravelEditPageParams>()

  // Breadcrumbs mirror TravelDetailsPage (spec: "same as TravelDetailsPage");
  // the Page shares the detail companion hook with the Feature Set (React
  // Query dedupes on the detail query key).
  const {
    data: { travel },
  } = useTravelDetailsPresenter({ uuid })

  // BHV-040 target: breadcrumb points to Approvals when the viewer can
  // approve, else to the Travel requests list.
  const breadcrumbTarget = travel?.canApprove
    ? {
        link: url('TravelApprovalsPage', {
          status: TravelApprovalsPageTabStatuses.PENDING,
        }),
        name: intl.formatMessage(messages.travelApprovalsPageTitle),
      }
    : {
        link: url('TravelStatusPage', {
          status: TravelStatusPageTabStatuses.PENDING,
        }),
        name: intl.formatMessage(messages.travelStatusPageTitle),
      }

  return (
    <Page
      pageTitle={intl.formatMessage(messages.travelDetailsPageTitle)}
      breadcrumbs={[
        breadcrumbTarget,
        {
          name: intl.formatMessage(messages.travelDetailsPageTitle),
        },
      ]}
    >
      <TravelEditViewChunk />
    </Page>
  )
}
